<template>
  <div>
    <div class="stripe-tips" v-if="type">Bezahlung erfolgreich!</div>
    <div class="stripe-tips" v-else>Bezahlung fehlgeschlagen!</div>
  </div>
</template>

<script>
import { getQueryString } from '@/utils/url.js'
export default {
  data () {
    return {
      type: true
    }
  },
  created () {
    let status = getQueryString('redirect_status')
    this.type = status === 'succeeded'
    this.$loading(true)
    setTimeout(() => {
      window.close()
      this.$loading(false)
    }, 1000)
  }
}
</script>

<style scoped>
.stripe-tips {
  color: #000;
  font-size: 40px;
  text-align: center;
  padding: 200px 0;
}
</style>
